import { useAuth } from "@/auth/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { GetMySummaryResponseDto } from "../generated/generatedTypes";

const getMyInfo = async (): Promise<GetMySummaryResponseDto> => {
  const response = await apiFetch("api/users/me/summary");
  if (!response.ok) throw new Error("GET api/users/me/summary failed");
  return response.json();
};

export function useGetMySummary({ enabled = true }: { enabled?: boolean } = {}) {
  const { user } = useAuth();
  return useQuery<GetMySummaryResponseDto, Error>({
    queryKey: ["myInfo", user?.id],
    queryFn: getMyInfo,
    enabled: !!user && enabled,
  });
}
